import { mainStore } from '@dinosband/bv-utils'
import { shouldExcludeMessage } from '@dinosband/bv-messenger-client'
import { Message } from '@dinosband/bv-messenger-schema'

export function filterOutInvalidMessages (messages: Message[], excludeDeleted: boolean | undefined): Message[] {
  let result: Message[]
  if (excludeDeleted) {
    result = messages.filter((i) => !i.deletedAt)
  } else {
    result = messages.filter((i) => !shouldExcludeMessage(i.deleteReason))
  }
  const blocked = mainStore.blockedProfileIds
  if (0 < blocked.length) {
    result = result.filter((i) => !blocked.includes(i.profileId))
  }
  const userId = mainStore.userId
  result = result.filter((i) => !i.props.designatedUserId ||
                                i.props.userId === userId ||
                                i.props.designatedUserId === userId)
  return result
}
